export default "__VITE_ASSET__DReW$qS4__"